import { useQuery } from "@apollo/client";
import {
  Formik,
  Form as FormikForm,
  FormikHelpers,
  FormikValues,
} from "formik";
import gql from "graphql-tag";
import React from "react";
import * as Yup from "yup";
import { Manager } from "../../schema";
import PrimaryButton from "../../ui/PrimaryButton";
import TextButton from "../../ui/TextButton";
import FormField from "../../ui/form/FormField";
import FormSection from "../../ui/form/FormSection";
import UIInput from "../../ui/form/UIInput";

type FormProps = {
  managerId: string;
  companyId: string;
  backLink: string;
  onSubmit?: (input: any) => void;
};

export default function CompanyEditManagerForm({
  managerId,
  backLink,
  companyId,
  onSubmit,
}: FormProps) {
  const onFormSubmit = (
    values: FormikValues,
    helpersReact: FormikHelpers<FormikValues>
  ) => {
    helpersReact.setSubmitting(true);
    if (onSubmit) {
      onSubmit(values);
      helpersReact.setSubmitting(false);
    }
  };

  const { loading, data } = useQuery<FormDataQuery>(query, {
    variables: {
      id: managerId,
      companyId,
    },
  });

  if (loading && !data) {
    return <div>Loading...</div>;
  }

  const initialValues = {
    firstName: data?.manager.firstName,
    lastName: data?.manager.lastName,
    email: data?.manager.email,
  };
  const validation = Yup.object().shape({
    firstName: Yup.string().required("Required"),
    lastName: Yup.string().required("Required"),
    email: Yup.string().email("Invalid email").required("Required"),
  });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validation}
      onSubmit={onFormSubmit}
    >
      {({ isSubmitting }) => (
        <FormikForm>
          <FormSection>
            <FormField id="firstName" label="First name">
              <UIInput name="firstName" id="firstName" className="w-full" />
            </FormField>
            <FormField id="lastName" label="Last name">
              <UIInput name="lastName" id="lastName" className="w-full" />
            </FormField>
            <input type="hidden" name="email" value={data?.manager.email} />
          </FormSection>
          <div className="pb-28">
            <div className="grid grid-cols-6 gap-4 items-start">
              <div className="col-span-3">
                <PrimaryButton loading={isSubmitting}>
                  {" "}
                  Save changes
                </PrimaryButton>
                <TextButton onClick={() => window.location.assign(backLink)}>
                  Cancel
                </TextButton>
              </div>
            </div>
          </div>
        </FormikForm>
      )}
    </Formik>
  );
}

interface FormDataQuery {
  manager: Manager;
}

const query = gql`
  query EditFormQuery($id: ID!, $companyId: ID!) {
    manager: companyManager(id: $id, companyId: $companyId) {
      id
      firstName
      lastName
      email
    }
  }
`;
